import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
    selector: '[blackTabsTrigger]',
    standalone: false
})
export class TabsTriggerDirective {  templateRef = inject<TemplateRef<any>>(TemplateRef);

}
